import { jsx as _jsx } from "react/jsx-runtime";
import SingleChoiceAnswer from './SingleChoiceAnswer';
const YesNoAnswer = ({ response, setResponse, disabled, }) => (_jsx(SingleChoiceAnswer, { availableAnswers: [
        {
            id: 'yes',
            answerText: 'Yes',
        },
        {
            id: 'no',
            answerText: 'No',
        },
    ], response: response, setResponse: setResponse, disabled: disabled }));
export default YesNoAnswer;
//# sourceMappingURL=YesNoAnswer.js.map